export default __webpack_public_path__ + "static/media/icon-twitter.6da71ee9.svg";